
export default function SQLs_Right_Join() {
  return (
    <div>
      <h1>SQL Right Join</h1>
      <p>Content for SQL Right Join will go here.</p>
    </div>
  );
}
